<template>
  <div>
    <el-table
      :data="users.data"
      :default-sort="{ prop: order_column, order: order_type }"
      class="w100"
      stripe
      v-loading="loading"
    >
      <el-table-column
        label="Name"
        prop="name"
        sortable
      ></el-table-column>
      <el-table-column label="Email" prop="email"></el-table-column>
      <el-table-column label="User" prop="fullname"></el-table-column>
      <el-table-column label="Asset Label" prop="asset_label"></el-table-column>
      <el-table-column label="Active" prop="active">
        <template slot-scope="props">
          <span v-if="props.row.active == 1">Yes</span>
          <span v-else>No</span>
        </template>
      </el-table-column>
      <el-table-column label="Actions" align="right" width="100%">
        <template slot-scope="props">
          <el-tooltip content="Edit" placement="top">
            <el-button
                type="warning"
                circle
                size="small"
                icon="el-icon-edit"
                @click="openEdit(props.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="float-right"
      background
      @current-change="currentChange"
      :current-page.sync="users.current_page"
      :page-size="page_size"
      layout="total, prev, pager, next, jumper"
      :total="users.total"
    ></el-pagination>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('youtubeUsers', [
      'users',
      'loading',
      'order_column',
      'order_type',
      'page_size'
    ])
  },

  methods: {
    ...mapMutations('youtubeUsers', ['setPage', 'setDialog', 'setSelectedUser']),
    ...mapActions('youtubeUsers', ['read']),
    currentChange(currentPage) {
      this.setPage(currentPage)
      this.read()
    },
    openEdit(user) {
      this.setDialog(true)
      this.setSelectedUser(user)
    },
  },

  created() {
    this.read()
  }
}
</script>
]
